import React, { Component } from "react";
import {
  Typography,
  Grid,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Chip,
} from "@material-ui/core";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, FormControl, Card } from "react-bootstrap";
import { PostData, GetData, DeleteData, PutData } from "../../api/service";
import Snack from "../Snackbar/Snack";
import FileUpload from "../AddNew/FileUpload";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import history from "../../history";
import FileUploadFaculty from "./FileUploadFaculty";
import { SERVER_UPLOAD } from "../../Helpers/GlobalVariables";

class FacultyWorkshop extends Component {
  state = {
    m_type: this.props.m_type,
    employee_id: this.props.employee_id,
    email:this.props.email,
    message: "",
    open: false,
    isLoaded: false,
   date_year:'',
   organised_by:'',
   theme:'',
   duration:'',
   sponsored_by:'',
   workshop:[]
  };


  onChange1 = (name, index, value) => {
    let d = this.state.workshop;
    d[index][name] = value
    this.setState({
      workshop: d
    })
  }


  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  onSetFile = (index, data) => {
    //console.log(data)
    let aw = this.state.workshop;
    aw[index]['file'] = data
    this.setState({
      workshop: aw
    })
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    //console.log(this.props);

    GetData(`/admin/${this.props.employee_id}/getsingleempolyeedataapi`)
    .then((resp)=>{
        if(resp){
            this.setState({
                ...resp,
          
               
              });
        }
        this.setState({
          isLoaded: true
        })
    })

    
  }

//   componentDidUpdate(prevProps){
//     if(this.props !== prevProps){
//         this.setState({
//             seminar:this.props.seminar
      
//         })
//     }
// }


  onSubmit = (e) => {
    e.preventDefault();

    let d = this.state;

    PostData(`/admin/${this.props.employee_id}/addemployeeapi`, d).then(
      (resp) => {
        //console.log(resp)
        this.setState({
          message: resp,
          open: true,
        });
      }
    );
  };


  onAddClick = () => {
    let d = {
        date_year: this.state.date_year,
        organised_by: this.state.organised_by,
        theme: this.state.theme,
        duration: this.state.duration,
        sponsored_by: this.state.sponsored_by,

    }

    let workshop = this.state.workshop != null ? this.state.workshop : [];
    workshop.push(d);
    this.setState({
        workshop
    }, () => {
            this.setState({
                date_year:'',
                organised_by:'',
                theme:'',
                duration:'',
                sponsored_by:'',
            })
    })
}

onDelete = (index) => {
    let workshop = this.state.workshop;
    workshop.splice(index,1);

    this.setState({
        workshop
    })
}

  render() {
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            message={this.state.message}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
          />
        ) : null}

{this.state.isLoaded && <form onSubmit={this.onSubmit}>
          <Typography variant="h6" gutterBottom>
            {this.props.title}
          </Typography>
          
           <table width="100%" className="table">
          <thead>
            <tr>
              <td>Date & Year</td>
              <td>Organized by</td>
              <td>Title</td>
              <td>Duration</td>

              <td>Sponsored by</td>
              <td></td>
              
              <td>Click + to Add</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  className="form-control"
                  type="text"
                  name="date_year"
                  value={this.state.date_year}
                  onChange={this.onChange}
                  placeholder="Date & Year"
                />
              </td>
              <td>
                <input
                  className="form-control"
                  type="text"
                  name="organised_by"
                  value={this.state.organised_by}
                  onChange={this.onChange}
                  placeholder="Organized by"
                />
              </td>
              <td>
                <input
                  className="form-control"
                  type="text"
                  name="theme"
                  value={this.state.theme}
                  onChange={this.onChange}
                  placeholder="Title"
                />
              </td>

              <td>
                <input
                  className="form-control"
                  type="text"
                  name="duration"
                  value={this.state.duration}
                  onChange={this.onChange}
                  placeholder="Duration"
                />
              </td>
              <td>
                <input
                  className="form-control"
                  type="text"
                  name="sponsored_by"
                  value={this.state.sponsored_by}
                  onChange={this.onChange}
                  placeholder="Sponsored by"
                />
              </td>
              <td>
               
               You can upload the files after additions
             </td>
              
              <td>
                <Button
                  variant="outlined"
                  onClick={this.onAddClick}
                  type="button"
                >
                  +
                </Button>
              </td>
            </tr>
          </tbody>
          <tbody>
            {Array.isArray(this.state.workshop) && this.state.workshop.map((el, index) => (
              <tr key={index}>
                <td>
                  
                <input
                      className="form-control"
                      type="text"
                      name="date_year"
                      value={el.date_year}
                      onChange={(e) => this.onChange1('date_year', index, e.target.value)}
                      placeholder="date_year"
                    />
                    
                   </td>
                <td>
                <textarea
                      className="form-control"
                      type="text"
                      name="organised_by"
                      value={el.organised_by}
                      onChange={(e) => this.onChange1('organised_by', index, e.target.value)}
                      placeholder="organised_by"
                    /></td>
                <td> <textarea
                      className="form-control"
                      type="text"
                      name="theme"
                      value={el.theme}
                      onChange={(e) => this.onChange1('theme', index, e.target.value)}
                      placeholder="theme"
                    /></td>
                <td><input
                      className="form-control"
                      type="text"
                      name="duration"
                      value={el.duration}
                      onChange={(e) => this.onChange1('duration', index, e.target.value)}
                      placeholder="duration"
                    /></td>
                <td><input
                      className="form-control"
                      type="text"
                      name="sponsored_by"
                      value={el.sponsored_by}
                      onChange={(e) => this.onChange1('sponsored_by', index, e.target.value)}
                      placeholder="sponsored_by"
                    /></td>
                <td style={{whiteSpace: 'nowrap'}}>
                  {Array.isArray(el.file) && el.file.map((el1,index1) => <div key={index1}><a target="_blank" href={`${SERVER_UPLOAD}/${el1.type}/${el1.path}`} style={{fontSize: 10}}>[uploaded] {el1.path}</a></div>)}
                  <FileUploadFaculty files={el.file} onSetFile={(data) => this.onSetFile(index,data)} type={`FACULTY_WORKSHOP`} dp={el.file} apikey={`1234`} />
                  </td>
                <td>
                  <Delete onClick={this.onDelete.bind(this, index)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
                <br />
        <div align="right">
                <Button size="sm" variant="info" type="submit">
                  Submit
                </Button>
              </div>
        
        </form>}
      </div>
    );
  }
}

export default FacultyWorkshop;
